import { camelize } from '../../utils';
import { theme } from '../../theme';

export const optionStyle = {
  ...camelize(theme.typography.uiText.md),
  borderBottom: `1px solid ${theme.colors.neutrals.solidGrays[5]}`,
  color: theme.colors.primary.graysGray,
  padding: `${theme.spacings[2].rem} ${theme.spacings[3].rem}`,
  display: 'flex',
  alignItem: 'center',
  gap: `0px ${theme.spacings[2].px}`,
};

export const controlStyle = {
  alignItems: 'center',
  cursor: 'pointer',
  display: 'flex',
  width: '100%',
};

export const indicatorSeparatorStyle = {
  display: 'none',
};

export const dropdownIndicatorStyle = {
  padding: '0',
  display: 'flex',
};

export const menuStyle = {
  position: 'absolute',
  width: 'max-content',
  backgroundColor: theme.colors.primary.white,
  border: `1px solid ${theme.colors.neutrals.solidGrays[5]}`,
  boxShadow: 'none',
  overflow: 'hidden',
  zIndex: 2,
};

export const menuPortalStyle = {
  top: 0,
  background: 'red',
};

export const singleValueStyle = {
  ...camelize(theme.typography.uiText.md),
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
};

export const valueContainerStyle = {
  display: 'flex',
  overflow: 'hidden',
};

export const placeholderStyle = {
  display: 'flex',
  alignItems: 'center',
  fontFamily: `${theme.fonts.roboto}`,
  gap: `${theme.spacings[3].rem}`,
  fontWeight: '700',
};
